import {gql} from '@apollo/client';

/**
 * 生效地址数据监控看板查询
 *
 * 指标由 quality 侧日任务算好落库，本查询只读 pod_exempt_metric_daily 的窗口聚合，
 * 不在前端做任何比率计算 —— 口径必须唯一，前端算会与抽查入池规则漂移。
 */
export const GET_MONITOR_ROWS = gql`
    query PodExemptMonitorRows(
        $filters: PodExemptMonitorFiltersInput
        $pageNum: Int!
        $pageSize: Int!
    ) {
        podExemptMonitorRows(filters: $filters, pageNum: $pageNum, pageSize: $pageSize) {
            content {
                targetType
                targetId
                address
                zipcode
                warehouseCode
                addressCount
                addressType
                dspId
                dspName
                orderCount
                complaintCount
                complaintCountDeltaRate
                monitorLevel
                triggerDetail
                hasSpotTaskInPeriod
            }
            total
        }
    }
`;

/** 指标字段可空，null 表示当日未取到，展示须为「-」而非「0」 */
export interface MonitorRowGql {
    targetType?: string | null;
    targetId?: number | null;
    address?: string | null;
    zipcode?: string | null;
    warehouseCode?: string | null;
    addressCount?: number | null;
    addressType?: string | null;
    dspId?: number | null;
    dspName?: string | null;
    orderCount?: number | null;
    complaintCount?: number | null;
    complaintCountDeltaRate?: number | null;
    monitorLevel?: string | null;
    triggerDetail?: string | null;
    hasSpotTaskInPeriod?: boolean | null;
}

export interface GetMonitorRowsResponse {
    podExemptMonitorRows: {
        content: MonitorRowGql[];
        total: number;
    };
}

/** 统计卡与列表共用筛选条件，保证卡片与列表口径一致 */
export const GET_MONITOR_STATS = gql`
    query PodExemptMonitorStats($filters: PodExemptMonitorFiltersInput) {
        podExemptMonitorStats(filters: $filters) {
            monitoringCount
            anomalyCount
            orderCount
            complaintCount
        }
    }
`;

export interface GetMonitorStatsResponse {
    podExemptMonitorStats: {
        monitoringCount: number;
        anomalyCount: number;
        orderCount?: number | null;
        complaintCount?: number | null;
    };
}
